module.exports = __webpack_public_path__ + "static/media/group.ebbbcd33.svg";